import { css } from 'styled-components'

import jetBrainsMono700Woff2 from './JetBrainsMono-v2.304/JetBrainsMono-Bold.woff2'
import jetBrainsMono500Woff2 from './JetBrainsMono-v2.304/JetBrainsMono-Medium.woff2'
import jetBrainsMono400Woff2 from './JetBrainsMono-v2.304/JetBrainsMono-Regular.woff2'
import poppinsLatin300Woff from './poppins-v15-latin/poppins-v15-latin-300.woff'
import poppinsLatin300Woff2 from './poppins-v15-latin/poppins-v15-latin-300.woff2'
import poppinsLatin400Woff from './poppins-v15-latin/poppins-v15-latin-400.woff'
import poppinsLatin400Woff2 from './poppins-v15-latin/poppins-v15-latin-400.woff2'
import poppinsLatin500Woff from './poppins-v15-latin/poppins-v15-latin-500.woff'
import poppinsLatin500Woff2 from './poppins-v15-latin/poppins-v15-latin-500.woff2'
import poppinsLatin600Woff from './poppins-v15-latin/poppins-v15-latin-600.woff'
import poppinsLatin600Woff2 from './poppins-v15-latin/poppins-v15-latin-600.woff2'
import poppinsLatin700Woff from './poppins-v15-latin/poppins-v15-latin-700.woff'
import poppinsLatin700Woff2 from './poppins-v15-latin/poppins-v15-latin-700.woff2'
import robotoLatin300Woff from './roboto-v27-latin/roboto-v27-latin-300.woff'
import robotoLatin300Woff2 from './roboto-v27-latin/roboto-v27-latin-300.woff2'
import robotoLatin400Woff from './roboto-v27-latin/roboto-v27-latin-400.woff'
import robotoLatin400Woff2 from './roboto-v27-latin/roboto-v27-latin-400.woff2'
import robotoLatin500Woff from './roboto-v27-latin/roboto-v27-latin-500.woff'
import robotoLatin500Woff2 from './roboto-v27-latin/roboto-v27-latin-500.woff2'
import robotoLatin700Woff from './roboto-v27-latin/roboto-v27-latin-700.woff'
import robotoLatin700Woff2 from './roboto-v27-latin/roboto-v27-latin-700.woff2'

export default css`/* poppins-300 - latin */
	/* stylelint-disable at-rule-descriptor-value-no-unknown */
	@font-face {
		font-family: 'Poppins';
		font-style: normal;
		font-weight: 300;
		src: local(''),
			url(${poppinsLatin300Woff2}) format('woff2'), /* Chrome 26+, Opera 23+, Firefox 39+ */
			url(${poppinsLatin300Woff}) format('woff'); /* Chrome 6+, Firefox 3.6+, IE 9+, Safari 5.1+ */
	}
	/* poppins-400 - latin */
	@font-face {
		font-family: 'Poppins';
		font-style: normal;
		font-weight: 400;
		src: local(''),
			url(${poppinsLatin400Woff2}) format('woff2'), /* Chrome 26+, Opera 23+, Firefox 39+ */
			url(${poppinsLatin400Woff}) format('woff'); /* Chrome 6+, Firefox 3.6+, IE 9+, Safari 5.1+ */
	}
	/* poppins-500 - latin */
	@font-face {
		font-family: 'Poppins';
		font-style: normal;
		font-weight: 500;
		src: local(''),
			url(${poppinsLatin500Woff2}) format('woff2'), /* Chrome 26+, Opera 23+, Firefox 39+ */
			url(${poppinsLatin500Woff}) format('woff'); /* Chrome 6+, Firefox 3.6+, IE 9+, Safari 5.1+ */
	}
	/* poppins-600 - latin */
	@font-face {
		font-family: 'Poppins';
		font-style: normal;
		font-weight: 600;
		src: local(''),
			url(${poppinsLatin600Woff2}) format('woff2'), /* Chrome 26+, Opera 23+, Firefox 39+ */
			url(${poppinsLatin600Woff}) format('woff'); /* Chrome 6+, Firefox 3.6+, IE 9+, Safari 5.1+ */
	}
	/* poppins-700 - latin */
	@font-face {
		font-family: 'Poppins';
		font-style: normal;
		font-weight: 700;
		src: local(''),
			url(${poppinsLatin700Woff2}) format('woff2'), /* Chrome 26+, Opera 23+, Firefox 39+ */
			url(${poppinsLatin700Woff}) format('woff'); /* Chrome 6+, Firefox 3.6+, IE 9+, Safari 5.1+ */
	}

	/* roboto-300 - latin */
	@font-face {
		font-family: 'Roboto';
		font-style: normal;
		font-weight: 300;
		src: local(''),
			url(${robotoLatin300Woff2}) format('woff2'), /* Chrome 26+, Opera 23+, Firefox 39+ */
			url(${robotoLatin300Woff}) format('woff'); /* Chrome 6+, Firefox 3.6+, IE 9+, Safari 5.1+ */
	}
	/* roboto-400 - latin */
	@font-face {
		font-family: 'Roboto';
		font-style: normal;
		font-weight: 400;
		src: local(''),
			url(${robotoLatin400Woff2}) format('woff2'), /* Chrome 26+, Opera 23+, Firefox 39+ */
			url(${robotoLatin400Woff}) format('woff'); /* Chrome 6+, Firefox 3.6+, IE 9+, Safari 5.1+ */
	}
	/* roboto-500 - latin */
	@font-face {
		font-family: 'Roboto';
		font-style: normal;
		font-weight: 500;
		src: local(''),
			url(${robotoLatin500Woff2}) format('woff2'), /* Chrome 26+, Opera 23+, Firefox 39+ */
			url(${robotoLatin500Woff}) format('woff'); /* Chrome 6+, Firefox 3.6+, IE 9+, Safari 5.1+ */
	}
	/* roboto-700 - latin */
	@font-face {
		font-family: 'Roboto';
		font-style: normal;
		font-weight: 700;
		src: local(''),
			url(${robotoLatin700Woff2}) format('woff2'), /* Chrome 26+, Opera 23+, Firefox 39+ */
			url(${robotoLatin700Woff}) format('woff'); /* Chrome 6+, Firefox 3.6+, IE 9+, Safari 5.1+ */
	}
	/* jetBrainsMono-400 */
	@font-face {
		font-family: 'JetBrains Mono';
		font-style: normal;
		font-weight: 400;
		src: local(''),
			url(${jetBrainsMono400Woff2}) format('woff2'), /* Chrome 26+, Opera 23+, Firefox 39+ */
	}
	/* jetBrainsMono-500 */
	@font-face {
		font-family: 'JetBrains Mono';
		font-style: normal;
		font-weight: 500;
		src: local(''),
			url(${jetBrainsMono500Woff2}) format('woff2'), /* Chrome 26+, Opera 23+, Firefox 39+ */
	}
	/* jetBrainsMono-700 */
	@font-face {
		font-family: 'JetBrains Mono';
		font-style: normal;
		font-weight: 700;
		src: local(''),
			url(${jetBrainsMono700Woff2}) format('woff2'), /* Chrome 26+, Opera 23+, Firefox 39+ */
	}
`
